<footer class="siu-footer" role="contentinfo" aria-labelledby="footerGiustizia">
  <h2 class="visually-hidden" id="footerGiustizia">
    {{ "FOOTER_SITE" | translate }}
  </h2>
  <!-- main -->
  <section class="siu-footer--main">
    <div class="container">
      <div class="row">
        <!-- SECTION LOGO -->
        <div class="col-12">
          <div class="row clearfix">
            <div class="col-lg-4">
              <div class="it-brand-wrapper pt-0">
                <a
                  [attr.title]="'BCK_HOME' | translate"
                  [routerLink]="!isUserLogged ? '/' : '/servizi'"
                >
                  <div>
                    <img
                      alt="{{ 'ALT_LOGO_SIU' | translate }}"
                      src="assets/SIUf_logo_footer.svg"
                    />
                  </div>
                </a>
              </div>
            </div>

            <div class="col-12 col-lg-8 siu-footer--main--loghi">
              <div class="siu-footer--main--logo">
                <a
                  [attr.title]="'REG_ABRUZZO_EXT' | translate"
                  href="https://www.regione.abruzzo.it/"
                  target="_blank"
                  class="d-inline-block"
                >
                  <img
                    src="assets/Regione_Abruzzo-logo-white.svg"
                    alt="{{ 'ALT_LOGO_REGIONE_ABRUZZO' | translate }}"
                  />
                </a>
              </div>

              <div class="siu-footer--main--logo">
                <a
                  [attr.title]="'NEXT_GENERATION_EU_EXT' | translate"
                  href="https://next-generation-eu.europa.eu/index_it"
                  target="_blank"
                  class="d-inline-block"
                >
                  <img
                    src="assets/finanziato_UE_logo_white.svg"
                    alt="{{ 'ALT_LOGO_UNIONE_EUROPEA' | translate }}"
                  />
                </a>
              </div>

              <div>
                <a
                  [attr.title]="'MIN_LAVORO_EXT' | translate"
                  href="https://www.lavoro.gov.it/"
                  target="_blank"
                  class="d-inline-block"
                >
                  <img
                    src="assets/Ministero_lavoro_logo_white.svg"
                    alt="{{ 'ALT_LOGO_MINISTERO_LAVORO' | translate }}"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <hr class="hr-footer-logo" aria-hidden="true" />
        </div>
        <!-- SECTION CONTATTI -->
        <div class="col-12">
          <div class="mb-4 font-size-1-125 h6">
            {{ "CONTACTS" | translate | uppercase }}
          </div>
          <div class="d-flex flex-row row">
            <div class="col-12 col-lg-4">
              <ul>
                <li class="section-subtitle">Sede L'Aquila</li>
                <li class="section-descr">
                  Via Leonardo da Vinci, 6 <br />
                  67100 L'Aquila
                </li>
                <li class="section-descr">
                  <span>Centralino: </span>
                  <a
                    href="tel:+39 08623631"
                    title="{{ 'GO_TO_TEL_NUMBER1' | translate }}"
                    >(+39) 0862 3631</a
                  >
                </li>
              </ul>
            </div>
            <div class="col-12 col-lg-4">
              <ul>
                <li class="section-subtitle">Sede Pescara</li>
                <li class="section-descr">
                  Piazza Unione, 13 <br />
                  65127 Pescara
                </li>
                <li class="section-descr">
                  <span>Centralino: </span>
                  <a
                    class="list-item tel-anchor"
                    href="tel:+39 0857671"
                    title="{{ 'GO_TO_TEL_NUMBER2' | translate }}"
                    >(+39) 085 7671</a
                  >
                </li>
              </ul>
            </div>
            <div class="col-12 col-lg-4">
              <ul>
                <li class="section-subtitle">
                  DPH - Dipartimento Lavoro e Attività Produttive
                </li>
                <li class="section-descr">
                  Via Passolanciano, 75 <br />
                  65124 Pescara
                </li>
                <li class="section-descr">
                  Email:
                  <a
                    href="mailto:dpg@regione.abruzzo.it"
                    title="{{ 'WRITE_EMAIL' | translate }}"
                    >dph@regione.abruzzo.it</a
                  >
                </li>
                <li class="section-descr">
                  Pec:
                  <a
                    href="mailto:dpg@pec.regione.abruzzo.it"
                    title="{{ 'WRITE_PEC' | translate }}"
                    >dph@pec.regione.abruzzo.it</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="mb-4 font-size-1-125 h6">
          {{ "FOLLOW_US" | translate | uppercase }}
        </div>
        <div class="siu-footer--main--social-links col-12 px-3">
          <a
            target="_blank"
            [attr.title]="'FACEBOOK_EXT' | translate"
            [href]="'https://www.facebook.com/RegAbruzzo'"
          >
            <img
              alt="{{ 'ALT_LOGO_FACEBOOK' | translate }}"
              src="../../../assets/facebook-logo-white.svg"
            />
          </a>
          <a
            target="_blank"
            [attr.title]="'TWITTER_EXT' | translate"
            [href]="'https://twitter.com/regione_abruzzo'"
          >
            <img
              alt="{{ 'ALT_LOGO_TWITTER' | translate }}"
              src="../../../assets/X-icon.svg"
            />
          </a>
          <a
            target="_blank"
            [attr.title]="'YOUTUBE_EXT' | translate"
            [href]="'https://www.youtube.com/user/WebtvRegioneAbruzzo'"
          >
            <img
              alt="{{ 'ALT_LOGO_YOUTUBE' | translate }}"
              src="../../../assets/youtube-logo-white.svg"
            />
          </a>
          <a
            target="_blank"
            [attr.title]="'VIMEO_EXT' | translate"
            [href]="'https://vimeo.com/user107766982'"
          >
            <img
              alt="{{ 'ALT_LOGO_VIMEO' | translate }}"
              src="../../../assets/vimeo-logo-white.svg"
            />
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- bottom -->
  <section class="siu-footer--bottom">
    <div class="container">
      <span class="visually-hidden h3 font-size-1-75 line-height-1-25">{{
        "USEFUL_URLS" | translate
      }}</span>
      <ul>
        <li class="list-inline-item link-sm">
          <a
            class="useful-link"
            href="https://www.regione.abruzzo.it/content/note-legali"
            >{{ "LEGAL_NOTICES" | translate }}</a
          >
        </li>
        <li class="list-inline-item link-sm">
          <a
            class="useful-link"
            href="https://www.regione.abruzzo.it/content/informativa-sulla-privacy"
            >{{ "PRIVACY_POLICY" | translate }}</a
          >
        </li>
      </ul>
    </div>
  </section>
</footer>
